import { render, staticRenderFns } from "./Benefeciaries.vue?vue&type=template&id=4ade54bd&scoped=true&"
import script from "./Benefeciaries.vue?vue&type=script&lang=js&"
export * from "./Benefeciaries.vue?vue&type=script&lang=js&"
import style0 from "./Benefeciaries.vue?vue&type=style&index=0&id=4ade54bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade54bd",
  null
  
)

export default component.exports